import CmsPackageService from '../Services/CmsPackageService';
import { useContext } from 'react';
import CmsPackageContext from '../Contexts/CmsPackageContext';
import { useConfig } from '@ibe/components';
import { useLocalObservable } from 'mobx-react';

function useCmsPackage(): CmsPackageService {
  const context = useContext(CmsPackageContext);
  const config = useConfig();
  const cmsService: CmsPackageService = useLocalObservable<CmsPackageService>(() => context);

  cmsService.apiUrl = config.apiUrl;

  return cmsService;
}

export default useCmsPackage;
